var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"square",style:(_vm.getSquareSize),on:{"click":function($event){return _vm.$emit('onIconClick')}}},[_c('feather-icon',{attrs:{"icon":_vm.icon,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }